export const filterCheck: any = {
  "EcoSystem": true,
  "Fix": true
};

export const ecoSystem: any = {
  "Maven": "Maven",
  "Alpine": "Alpine",
  "GIT": "GIT",
  "PYPI": "PYPI"
};

export const fix: any = {
  "Fix Available": "Fix Available",
  "No Fix Available": "No Fix Available"
};
